import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchInvoiceJustificationActions as Actions,
  FetchInvoiceJustificationRequestAction as RequestAction,
} from 'store/ducks/invoiceJustifications';

export function* fetchInvoiceJustificationRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, `invoice/justifications/${id}`);

    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
